export default __webpack_public_path__ + "static/media/dog-walk.icon.cdbf9c74.png";